import { AnyAtomInstance, AnyAtomTemplate, atom, AtomGetters, AtomParamsType, AtomStateType, injectAtomState, injectAtomValue, injectStore, ion, ParamlessTemplate, useAtomState, useAtomValue } from '@zedux/react'
import { userFilterAtom } from './atoms/atoms'
import { topicsAtom } from './atoms/topicsAtom'
import { contactsListAtom } from './atoms/socket'
import { IFilterMessagesTypes, IMessage, IMessages, IUserInfo, ITopic } from './types'

export const messageFilterAtom = atom("messageFilter",
    { shouldFilter: false, text: "", mime_type: "text" } as IFilterMessagesTypes)


export const getVisibleMessages = (topic_id: number, filter: IFilterMessagesTypes | string, atomValue: IMessages) => {
    if (atomValue.messages[topic_id] == null || atomValue.messages[topic_id] == undefined) return []
    let todoList: IMessage[] = Object.values(atomValue.messages[topic_id]).map(msg => ({ ...msg }))
    todoList.sort((a, b) => a.created_at - b.created_at)

    if (filter == "") return [...todoList]
    filter = filter as IFilterMessagesTypes
    if (!filter.shouldFilter || (filter.text.length === 0 && filter.mime_type == "text")) return [...todoList]
    if (filter.mime_type.startsWith("text")) {
        return todoList.filter((msg) => msg.text.includes(filter.text))
    } else if (filter.mime_type == "date") {
        return todoList.filter((msg) => msg.created_at >= filter.dateStart! && msg.created_at <= filter.dateStart!)

    } else if (filter.mime_type != "other") {
        return todoList.filter((msg) => msg.mime_type?.startsWith(filter.mime_type))
    }
    return todoList.filter((msg) => !msg.mime_type?.startsWith("image") && !msg.mime_type?.startsWith("text") && !msg.mime_type?.startsWith("video") && !msg.mime_type?.startsWith("audio"))
}

export const getVisibleUsers = ({ get }: AtomGetters) => {
    return get(contactsListAtom)
}

// export const getVisibleTopics = ({ get }: AtomGetters, tab: number, filter_topic: string, userType: string) => {
//     const topic_values = get(topicsAtom)
//     let topics: ITopic[] = Object.values(topic_values).sort((b, a) => a.msg_created_at - b.msg_created_at)
//     return topics

//     const { role } = { } // useAtomValue(userInfoAtom) as IUserInfo

//     if ((role != 1 && role != 3) || userType == "support") {
//         if (filter_topic.length == 0) {
//             return topics.filter((t: ITopic) => t.topic_name.includes(filter_topic) || Object.values(t.other_user_display).filter(name => name.includes(filter_topic)).length > 0)
//         }
//         return topics;
//     } else {

//         switch (tab) {
//             case 0:
//                 return topics.filter(t => Object.values(t.other_user_role).filter(r => r == "1" || r == "3" || r == "6").length > 0 && !t.topic_name && userType != "admin")
//             case 1:
//                 return topics.filter(t => !!t.topic_name)
//             case 2:
//                 return topics.filter(t => Object.values(t.other_user_role).filter(r => r == "4" || r == "5").length > 0 && !t.topic_name)
//             default:
//                 return topics
//         }
//     }
// }